import React from "react";

import { Box } from "styles/globalComponents";

import { LoadingText } from "Components/LoadingText";

import PageHeader from "Components/Pages/Header";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { Button } from "Components/Button";
import Select from "Components/Form/Select";
import { Modal } from "Components/Modals/Modal";
import { useParams } from "react-router";
import Attention from "Assets/Images/atention.svg";
import CartDetails from "./components/CartDetails";
import { PageMain, PageContainer, PageContent, PageHeading } from "./style";
import { Tabs } from "./components/Tabs";
import { useClientsBudgetService } from "./hooks/useClientsBudgetService";
import { ConvertOrderModal } from "./components/ConvertOrderModal";

const ClientsBudgetService = () => {
  const {
    isRetrivingBudget,
    data,
    cancelBudget,
    onConvertOrder,
    openUnitModal,
    setOpenUnitModal,
    unitSelected,
    cancelConvertOrder,
    openHomeFeeModal,
    setCancelModal,
    setUnitSelected,
    onSelectUnit,
    moveToConvertOrder,
    setOpenHomeFeeModal,
    modalProductsError,
    setModalProductsError,
    cancelModal,
    onCancelBudget,
    units,
    loading,
    blockConvertButton,
    blockUnitButton,
    blockCancelButton,
    isError,
    openConvertOrderModal,
    setOpenConvertOrderModal,
    handleConfirmConvertOrder,
  } = useClientsBudgetService();
  const { id } = useParams<{ id: string }>();

  if (isRetrivingBudget) {
    return (
      <PageContainer className="entry-app-content entry-budget">
        <PageContent className="content-holder full-w-page">
          <Box mt="300">
            <LoadingText text="Aguarde ! Estamos recuperando os dados do orçamento salvo." />
          </Box>
        </PageContent>
      </PageContainer>
    );
  }

  if (isError) {
    return (
      <PageContainer className="entry-app-content entry-budget">
        <PageContent className="content-holder full-w-page">
          <Box mt="300">
            <h3 className="text-center text-purple">
              Não foi possível recuperar este orçamento
            </h3>
          </Box>
        </PageContent>
      </PageContainer>
    );
  }

  return (
    <PageContainer className="entry-app-content entry-budget">
      <PageContent className="content-holder">
        <PageHeading className="page-heading">
          <div className="wrapper-header-content m-bottom-1 order-budget">
            <PageHeader title="Orçamentos" isBudget>
              <Breadcrumb
                list={[
                  {
                    path: "/orcamentos/parceiro/domiciliar",
                    label: "Orçamento",
                    current: false,
                  },
                  {
                    path: "#",
                    label: "Criar novo",
                    current: true,
                  },
                ]}
              />
              <p className="id-order-budget">#{id}</p>
            </PageHeader>

            <div className="budget-header-user">
              <h5>Criando orçamento para:</h5>
              <p>{data?.patient?.name}</p>
              <p>{data?.patient?.document.number}</p>
              <button>Ver todos orçamentos</button>
            </div>
          </div>
        </PageHeading>

        <PageMain>
          <Tabs />
        </PageMain>

        <CartDetails>
          <div className="actions-cart-budget">
            <Box display="flex" direction="column" gap="5">
              <Button
                width="full"
                onClick={() => setOpenUnitModal(true)}
                loading={units.isLoading}
                disabled={blockUnitButton}
              >
                {data?.unit?.id ? "Alterar unidade" : "Selecionar unidade"}
              </Button>

              <Button
                width="full"
                disabled={blockConvertButton}
                onClick={onConvertOrder}
                loading={loading}
              >
                Converter em pedido
              </Button>
              <Button
                width="full"
                outlined
                onClick={() => setCancelModal(true)}
                loading={cancelBudget.isLoading}
                disabled={blockCancelButton}
              >
                CANCELAR ORÇAMENTO
              </Button>
            </Box>
          </div>
        </CartDetails>
      </PageContent>

      <Modal
        closeOverlay
        isOpen={openUnitModal}
        requestClose={() => setOpenUnitModal(false)}
        renderHeading={() => <h2>Selecione uma unidade abaixo</h2>}
        renderActions={() => (
          <Box display="flex" direction="column" className="box-select-unit">
            <Select
              id="unit"
              value={unitSelected}
              readOnly={!units?.data?.length}
              optionName="name"
              placeholder="Unidades"
              onChange={(unit: any) => setUnitSelected(unit.target.value)}
              options={units.data}
            />

            <Button onClick={onSelectUnit} loading={loading} disabled={loading}>
              Confirmar
            </Button>
          </Box>
        )}
      />

      <Modal
        closeOverlay={false}
        isOpen={openHomeFeeModal}
        modalIcon={Attention}
        requestClose={cancelConvertOrder}
        renderHeading={() => (
          <h2 className="text-center">
            Este convênio pode exigir cobrança de taxa domiciliar.
          </h2>
        )}
        renderActions={() => (
          <Box display="flex" justify="center">
            <Button onClick={cancelConvertOrder}>Adicionar produto</Button>
            <Button outlined onClick={moveToConvertOrder}>
              Continuar
            </Button>
          </Box>
        )}
      />

      <Modal
        closeOverlay
        isOpen={modalProductsError}
        requestClose={() => setModalProductsError(false)}
        modalIcon={Attention}
        renderHeading={() => (
          <h2 className="text-center">
            Os produtos abaixo não foram adicionados ao carrinho
          </h2>
        )}
        renderDescription={() => (
          <Box>
            {data?.errors?.map((error) => (
              <Box>
                {error?.product} - {error.message}{" "}
              </Box>
            ))}
          </Box>
        )}
        renderActions={() => (
          <Button onClick={() => setModalProductsError(false)}>
            Continuar
          </Button>
        )}
      />

      <Modal
        closeOverlay
        isOpen={cancelModal}
        requestClose={() => setCancelModal(false)}
        modalIcon={Attention}
        renderHeading={() => (
          <h2 className="text-center">
            Ao prosseguir com o cancelamento a ação não poderá ser desfeita!
          </h2>
        )}
        renderDescription={() => (
          <Box>
            <h2 className="text-center">Deseja continuar ?</h2>
          </Box>
        )}
        renderActions={() => (
          <Box display="flex" justify="center">
            <Button
              onClick={onCancelBudget}
              loading={cancelBudget.isLoading}
              disabled={cancelBudget.isLoading}
            >
              Continuar
            </Button>
            <Button
              outlined
              onClick={() => setCancelModal(false)}
              disabled={cancelBudget.isLoading}
            >
              Voltar
            </Button>
          </Box>
        )}
      />

      {data?.files && data.files.length > 0 && (
        <ConvertOrderModal
          isOpen={openConvertOrderModal}
          onClose={() => setOpenConvertOrderModal(false)}
          onConfirm={handleConfirmConvertOrder}
          files={data.files.map((file) => ({ file_path: file }))}
          products={data?.cart || []}
          budgetId={Number(id)}
        />
      )}
    </PageContainer>
  );
};

export default ClientsBudgetService;
